import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';

export const useOnReady = (onReady: () => void) => {
    useInstanceEffect((instance) => instance.onReady(onReady), [onReady]);
};
